"use client";
import React, { createContext, useContext, useState } from 'react';

// Create context for locale state
interface LocaleContextType {
  activeLocale: string;
  setActiveLocale: (locale: string) => void;
  availableLocales: string[];
  fallbackLocale: string;
}

const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

const LocaleProvider: React.FC<{
  children: React.ReactNode;
  availableLocales?: string[];
  fallbackLocale?: string;
}> = ({ children, availableLocales = [], fallbackLocale = 'en' }) => {
  const [activeLocale, setActiveLocale] = useState<string>(fallbackLocale);
  
  return (
    <LocaleContext.Provider value={{
      activeLocale,
      setActiveLocale,
      availableLocales,
      fallbackLocale
    }}>
      {children}
    </LocaleContext.Provider>
  );
};

const useLocale = () => {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
};

export { LocaleProvider, useLocale };